// src/index.js
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import store from "./store";
import { RouterProvider } from "react-router-dom";
import router from "./routes/router";

// ✅ Import MUI LicenseInfo here
import { LicenseInfo } from "@mui/x-data-grid-pro";

// ✅ Set the license key using your env variable
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CssBaseline enableColorScheme />
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
